export default{
  // baseURL:'http://localhost:9191/voith/'
  // baseURL:'http://192.168.1.119:8080/voith/'  //  测试
  // baseURL:'http://180.167.18.22:21988/voith/'  //  测试
  baseURL:'https://apac-einvoice.voith.com.cn:8080/voith/'  //  正式
}